// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Container */
.category-container {
  padding: 20px;
  /* background-color: #ffffff; */
  border-radius: 10px;
}

/* Header Bar */
.header-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

/* Search */
.search-bar {
  padding: 8px 12px;
  width: 250px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  transition: 0.2s ease;
}

.search-bar:focus {
  border-color: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.15);
}

/* Add Button */
.add-btn {
  padding: 8px 14px;
  background-color: #22c55e;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: 0.2s ease;
}

.add-btn:hover {
  background-color: #16a34a;
}

/* Table Compact */
.compact-table th,
.compact-table td {
  padding: 6px 10px;
  font-size: 14px;
}

.compact-table tr {
  height: 38px;
}

/* Status Badge */
.status-badge {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  transition: 0.2s ease;
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 15px;
  gap: 10px;
}

.pagination button {
  padding: 6px 12px;
  border: 1px solid #ddd;
  background: #f9f9f9;
  cursor: pointer;
  border-radius: 5px;
  font-size: 13px;
  transition: 0.2s ease;
}

.pagination button:hover:not(:disabled) {
  background-color: #e5e5e5;
}

.pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination span {
  font-weight: 500;
  font-size: 14px;
}

/* Action Icons */
.action-icons {
  display: flex;
  gap: 12px;
}

.icon-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  transition: 0.2s ease;
}

.icon-btn:hover {
  color: #22c55e;
  transform: scale(1.1);
}

/* Modal Overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

/* Modal Box */
.modal-content {
  background: #ffffff;
  padding: 20px 30px;
  border-radius: 12px;
  max-width: 420px;
  width: 90%;
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.2s ease-in-out;
}

.modal-content h3 {
  margin-bottom: 15px;
  font-size: 18px;
}

/* Details Table */
.details-table {
  width: 100%;
  border-collapse: collapse;
}

.details-table td {
  padding: 6px 4px;
  font-size: 14px;
}

.details-table tr td:first-child {
  font-weight: 600;
  width: 40%;
}
.filter-select {
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #334155;
  font-size: 14px;
  background-color: #0f172a;
  color: #e2e8f0;
  height: 38px;
  min-width: 140px;
  outline: none;
  appearance: none;
  cursor: pointer;
}

.filter-select:focus {
  border-color: #facc15;
  box-shadow: 0 0 0 1px #facc15;
}

/* Smooth Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Masters/metal_purity_karat/metal_purity_karatList/metal_purity_karatList.css"],"names":[],"mappings":";AACA,cAAc;AACd;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;;EAEE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,qBAAqB;AACrB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["\n/* Container */\n.category-container {\n  padding: 20px;\n  /* background-color: #ffffff; */\n  border-radius: 10px;\n}\n\n/* Header Bar */\n.header-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n/* Search */\n.search-bar {\n  padding: 8px 12px;\n  width: 250px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  outline: none;\n  transition: 0.2s ease;\n}\n\n.search-bar:focus {\n  border-color: #22c55e;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.15);\n}\n\n/* Add Button */\n.add-btn {\n  padding: 8px 14px;\n  background-color: #22c55e;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: 0.2s ease;\n}\n\n.add-btn:hover {\n  background-color: #16a34a;\n}\n\n/* Table Compact */\n.compact-table th,\n.compact-table td {\n  padding: 6px 10px;\n  font-size: 14px;\n}\n\n.compact-table tr {\n  height: 38px;\n}\n\n/* Status Badge */\n.status-badge {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  display: inline-block;\n  transition: 0.2s ease;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 15px;\n  gap: 10px;\n}\n\n.pagination button {\n  padding: 6px 12px;\n  border: 1px solid #ddd;\n  background: #f9f9f9;\n  cursor: pointer;\n  border-radius: 5px;\n  font-size: 13px;\n  transition: 0.2s ease;\n}\n\n.pagination button:hover:not(:disabled) {\n  background-color: #e5e5e5;\n}\n\n.pagination button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.pagination span {\n  font-weight: 500;\n  font-size: 14px;\n}\n\n/* Action Icons */\n.action-icons {\n  display: flex;\n  gap: 12px;\n}\n\n.icon-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  transition: 0.2s ease;\n}\n\n.icon-btn:hover {\n  color: #22c55e;\n  transform: scale(1.1);\n}\n\n/* Modal Overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n/* Modal Box */\n.modal-content {\n  background: #ffffff;\n  padding: 20px 30px;\n  border-radius: 12px;\n  max-width: 420px;\n  width: 90%;\n  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.2);\n  animation: fadeIn 0.2s ease-in-out;\n}\n\n.modal-content h3 {\n  margin-bottom: 15px;\n  font-size: 18px;\n}\n\n/* Details Table */\n.details-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.details-table td {\n  padding: 6px 4px;\n  font-size: 14px;\n}\n\n.details-table tr td:first-child {\n  font-weight: 600;\n  width: 40%;\n}\n.filter-select {\n  padding: 8px 12px;\n  border-radius: 8px;\n  border: 1px solid #334155;\n  font-size: 14px;\n  background-color: #0f172a;\n  color: #e2e8f0;\n  height: 38px;\n  min-width: 140px;\n  outline: none;\n  appearance: none;\n  cursor: pointer;\n}\n\n.filter-select:focus {\n  border-color: #facc15;\n  box-shadow: 0 0 0 1px #facc15;\n}\n\n/* Smooth Animation */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
